import React, { useEffect, useMemo, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import {
    type Container,
    type ISourceOptions,
} from '@tsparticles/engine';
import { loadSlim } from '@tsparticles/slim';
import { Box } from 'native-base';

const Confetti = () => {

    const [init, setInit] = useState(false);

    useEffect(() => {

        initParticlesEngine(async (engine) => {

            await loadSlim(engine);
        }).then(() => {

            setInit(true);
        });
    }, []);

    const particlesLoaded = async (container?: Container): Promise<void> => {

        await console.log(container, init);
    };

    const options: ISourceOptions = useMemo(
        () => ({
            fullScreen: {
                zIndex: -1
            },
            particles: {
                color: {
                    value: [
                        '#128FF9',
                        '#6044F8',
                        '#45F0B0',
                    ]
                },
                move: {
                    direction: 'bottom',
                    enable: true,
                    outModes: {
                        default: 'out'
                    },
                    size: true,
                    speed: {
                        min: 5,
                        max: 9
                    }
                },
                number: {
                    value: 200,
                    density: {
                        enable: true,
                        area: 800
                    }
                },
                opacity: {
                    value: 1,
                    animation: {
                        enable: false,
                        startValue: 'max',
                        destroy: 'min',
                        speed: 0.3,
                        sync: true
                    }
                },
                rotate: {
                    value: {
                        min: 0,
                        max: 360
                    },
                    direction: 'random',
                    move: true,
                    animation: {
                        enable: true,
                        speed: 60
                    }
                },
                tilt: {
                    direction: 'random',
                    enable: true,
                    move: true,
                    value: {
                        min: 0,
                        max: 360
                    },
                    animation: {
                        enable: true,
                        speed: 60
                    }
                },
                shape: {
                    type: 'square',
                    options: {}
                },
                size: {
                    value: {
                        min: 2,
                        max: 5
                    }
                },
                roll: {
                    darken: {
                        enable: true,
                        value: 10
                    },
                    enlighten: {
                        enable: true,
                        value: 10
                    },
                    enable: true,
                    speed: {
                        min: 15,
                        max: 25
                    }
                },
                wobble: {
                    distance: 30,
                    enable: true,
                    move: true,
                    speed: {
                        min: -15,
                        max: 15
                    }
                }
            }
        }),
        [],
    );

    return (
        <Box>
            <Particles
                id="tsparticles"
                particlesLoaded={particlesLoaded}
                options={options}
            />
        </Box>
    );
};

export default Confetti;
